// extracted by mini-css-extract-plugin
module.exports = {"singleCta":"SingleCtaShop_singleCta__Bl5LV"};